import { dataLayerPush } from '../gtm';
import type { EventContractMap } from '../types/analyticsEvents';

export const Analytics = {
    on<Event extends keyof EventContractMap>(action: Event, data: EventContractMap[Event]): void {
        dataLayerPush({ ...data, event: action });
    },
};
